module.exports = __webpack_public_path__ + "img/littleImg07.f144924a.gif";